import { PopupConfig } from "../context/popupContext"
import { twElementStyles } from "../twElementStyles"
import { DialogWrapper } from "./dialogWrapper"
import { Button } from "./ui/button"
interface ComponentProps {
    isOpen: boolean
    config: PopupConfig
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}
export const PopupComponent: React.FC<ComponentProps> = ({isOpen, config, setIsOpen}) => {
    const handleAction = (value: boolean) => {
        setIsOpen(false)
        if (config.onAction) config.onAction(value)
    }
    return (
        <DialogWrapper isOpen={isOpen} setIsOpen={setIsOpen} title={config.title}>
            <div>{config.message}</div>
            <div className="w-full flex items-center justify-end gap-3 pt-[10px]">
                <Button color="gray" onClick={()=>handleAction(false)} className={config.cancelButtonClass}>{config.cancelButtonText ?? 'Cancel'}</Button>
                <Button color="blue" onClick={()=>handleAction(true)} className={config.confirmButtonClass}>{config.confirmButtonText ?? 'Confirm'}</Button>
            </div>
        </DialogWrapper>
    )
}